import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import Helmet from "react-helmet";
import SEO from "../components/SEO"
import config from "../meta/config"

export default ({ data, children }) => {
  const {
    social_links,
    header,
    locations
  } = data.allBusinessJson.edges[0].node;


  return <div>

      <SEO title={config.siteTitle}
           description={config.siteDescription}/>
      <Navigation name={header.title} />
      {children()}
      <Footer 
          linkedin={social_links.linkedin} 
          facebook={social_links.facebook} 
          email={social_links.email} 
          name={header.title}
          phone={social_links.phone}
      />
    </div>;
};

export const query = graphql`
         query LayoutQuery {
           allBusinessJson {
             edges {
               node {
                 header {
                   title
                   headline
                   subline
                 }
                 mission_statement
                 locations {
                   street
                   city
                   zip
                   state
                 }
                 social_links {
                   email
                   linkedin
                   facebook
                   phone
                 }
               }
             }
           }
         }
       `;



// WEBPACK FOOTER //
// ./src/layouts/index.js